import enUS from "../../../locale/errorCode/en-US.json";
import zhCN from "../../../locale/errorCode/en-US.json";
import jaJP from "../../../locale/errorCode/en-US.json";
import useIntlStore from "@/stores/useIntlStore";
import { getT } from "../intlUtils";

const getDiffLocaleMessages = () => {
  const { locale } = useIntlStore.getState();

  switch (locale) {
    case "zh-CN":
      return zhCN;
    case "en-US":
      return enUS;
    case "ja-JP":
      return jaJP;
    default:
      return zhCN;
  }
};

export const getErrorMessage = (
  code: keyof ReturnType<typeof getDiffLocaleMessages>,
  defaultMessage?: string,
) => {
  const t = getT();

  const messages = getDiffLocaleMessages();

  return messages[code] || defaultMessage || t("未知错误");
};
